var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHubspotChatOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 5.19974 0 3.79961 0.544967 2.73005C1.02433 1.78924 1.78924 1.02433 2.73005 0.544967C3.79961 0 5.19974 0 8 0H22C24.8003 0 26.2004 0 27.27 0.544967C28.2108 1.02433 28.9757 1.78924 29.455 2.73005C30 3.79961 30 5.19974 30 8V17C30 19.8003 30 21.2004 29.455 22.27C28.9757 23.2108 28.2108 23.9757 27.27 24.455C26.2004 25 24.8003 25 22 25H11.1396C10.0995 25 9.57945 25 9.08202 25.1021C8.64071 25.1927 8.21366 25.3425 7.81248 25.5474C7.36028 25.7784 6.9542 26.1033 6.14202 26.753L2.16626 29.9337C1.47278 30.4884 1.12605 30.7658 0.834233 30.7661C0.580449 30.7664 0.340371 30.651 0.182048 30.4527C0 30.2246 0 29.7806 0 28.8925V8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubspotChatOpen);
export default __webpack_public_path__ + "static/media/hubspot-chat-open.09bf9ce44b446246159f189eb1a2287a.svg";
export { ForwardRef as ReactComponent };